import React, { Fragment, useEffect, useState } from "react";
import Navbar2 from "../../components/Navbar2/Navbar2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import client, { urlFor } from "../../sanity/sanityClient";
import { PortableText } from "@portabletext/react";
import { useParams } from "react-router-dom";

const EventSinglePage = () => {
  const { slug } = useParams();
  const [eventDetails, setEventDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "event" && slug.current == $slug][0]{
          title,
          date,
          time,
          location,
          body,
          cta,
          mainImage
        }`,
        { slug }
      )
      .then((data) => {
        setEventDetails(data);
        setIsLoading(false);
      })
      .catch(console.error);
  }, [slug]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  if (isLoading) return <p>Loading event details...</p>;
  if (!eventDetails) return <p>Event not found.</p>;

  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={eventDetails.title} pagesub="Events" />
      <div className="wpo-event-details-area">
        <div className="container">
          <div className="wpo-event-details-wrap">
            {/* Event Image */}
            {eventDetails.mainImage && (
              <div className="wpo-event-details-img">
                <img
                  src={urlFor(eventDetails.mainImage).width(800).url()}
                  alt={eventDetails.title}
                />
              </div>
            )}

            {/* Event Metadata */}
            <div className="wpo-event-details-meta">
              <span>
                <i className="fa fa-calendar"></i>
                {formatDate(eventDetails.date)}
              </span>
              <span>
                <i className="fa fa-clock-o"></i>
                {eventDetails.time}
              </span>
              <span>
                <i className="fa fa-map-marker"></i>
                {eventDetails.location}
              </span>
            </div>

            {/* Event Body */}
            <div className="wpo-event-details-text">
              <h2>About the Event</h2>
              <PortableText value={eventDetails.body} />
            </div>

            {/* Call to Action Button */}
            {eventDetails.cta && (
              <div
                className="wpo-event-details-cta"
                style={{ marginTop: "20px" }}
              >
                <a
                  href={eventDetails.cta.ctaLink}
                  className="cta-button"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    padding: "10px 20px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: "5px",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                >
                  {eventDetails.cta.ctaText}
                </a>
              </div>
            )}

            {/* Share Section */}
            <div className="wpo-event-details-share">
              <span>Share This Event:</span>
              <a
                href={`https://facebook.com/sharer/sharer.php?u=${window.location.href}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-facebook"></i>
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${window.location.href}`}
                target="_blank"
                rel="noopener noreferrer"
                className="twitter"
              >
                <i className="fa fa-twitter"></i>
              </a>
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin"
              >
                <i className="fa fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default EventSinglePage;
